/** Fetch discipline for open-data services (§8 etiquette): timeouts, typed failures,
 *  no retter-storms — one retry only where a documented mirror exists. */

export class ServiceError extends Error {
  constructor(
    public readonly service: string,
    public readonly kind: 'timeout' | 'http' | 'malformed' | 'network' | 'empty' | 'guard',
    message: string,
  ) { super(message); }
}

export interface FetchOpts {
  method?: 'GET' | 'POST';
  body?: string;
  contentType?: string;
  timeoutMs?: number;
}

export async function fetchJson(service: string, url: string, opts: FetchOpts = {}): Promise<unknown> {
  const ctl = new AbortController();
  const t = setTimeout(() => ctl.abort(), opts.timeoutMs ?? 12000);
  let res: Response;
  try {
    res = await fetch(url, {
      method: opts.method ?? 'GET',
      body: opts.body,
      headers: opts.body ? { 'Content-Type': opts.contentType ?? 'application/x-www-form-urlencoded' } : undefined,
      signal: ctl.signal,
    });
  } catch (e) {
    clearTimeout(t);
    if ((e as Error).name === 'AbortError') throw new ServiceError(service, 'timeout', `${service} did not answer within ${(opts.timeoutMs ?? 12000) / 1000}s`);
    throw new ServiceError(service, 'network', `${service} could not be reached`);
  }
  clearTimeout(t);
  if (!res.ok) throw new ServiceError(service, 'http', `${service} answered with HTTP ${res.status}`);
  try {
    return await res.json();
  } catch {
    throw new ServiceError(service, 'malformed', `${service} answered with something that is not valid JSON`);
  }
}
